import { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationForgotPasswordSchema = (t: TFunction<'translation', undefined>) =>
  yup.object({
    code: yup
      .string()
      .required(t('userAuth.validationErrors.required')),
    password: yup
      .string()
      .min(8, t('userAuth.validationErrors.minLength'))
      .matches(/^[^\s]*$/, t('userAuth.validationErrors.noSpacesAllowed'))
      .required(t('userAuth.validationErrors.required')),
    repeatPassword: yup
      .string()
      .oneOf([yup.ref('password'), undefined], t("userAuth.validationErrors.passwordsMustMatch"))
      .required(t('userAuth.validationErrors.required')),
  });
